import { render, staticRenderFns } from "./BackBtn.vue?vue&type=template&id=115b6742&scoped=true"
import script from "./BackBtn.vue?vue&type=script&lang=ts"
export * from "./BackBtn.vue?vue&type=script&lang=ts"
import style0 from "./BackBtn.vue?vue&type=style&index=0&id=115b6742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b6742",
  null
  
)

export default component.exports